import React, {useEffect, useRef} from "react"
import GamePageLayout from '../../components/GamePageLayout';
import {Util} from "baziigram";
import {dictionary} from "../../constants"
import {installDictionary} from "../../constants/installHelp"

const HelpPage =(props)=> {

    const [language , setLanguage] = React.useState("en")
    const [className , setClassName] = React.useState("ltr text-left")

    React.useEffect(()=>{
    setLanguage(Util.getLanguage())
    if(language == "fa")
     setClassName("rtl text-right")
    },[language])


    return <GamePageLayout  >
        <div className={`${className } w-100 h-100 p-3  d-flex flex-column justify-content-between`}>
            <div >
            <img style={{margin:"5px auto",display:"block"}}  width={"100px"} height={"100px"} src={"/images/icons/neon2nahai 2 (1).png"}/>
                {Util.Platform.isIOS() && <div className="mt-3">
                <div className={"my-3"}> {installDictionary.iosInstall[language]} :</div>
                <div className={`${className} iva-help-section mb-2`}>
                    <ol>
                        <li>{installDictionary.select[language]} <img src="/images/icons/icon_ios_share.png" height="32px" /> {installDictionary.bottomBar[language]}</li>
                        <br/>
                        <li>{installDictionary.select[language]} <img src="/images/icons/icon_ios_plus.png" height="32px" /> {installDictionary.right[language]}</li>
                        <br/>
                        <li>{installDictionary.select[language]} <span style={{color:"#c474e6"}} className="ml-2 mr-2 ">Add</span> {installDictionary.top[language]}</li>
                    </ol>
                </div>

            </div>}
                {!Util.Platform.isIOS() && <div className="mt-3">
                    <div className={"my-3"}> {installDictionary.androidInstall[language]} :</div>
                    <div className={`${className} iva-help-section mb-2`}>
                        <ol>
                            <li>{installDictionary.select[language]} <img src="/images/icons/more.png" height="25px" /> {installDictionary.topBar[language]}</li>
                            <br/>
                            <li>{installDictionary.select[language]} <span style={{color:"#c474e6"}} className={"mx-1"}>Add To Home Screen</span> {installDictionary.expandedMenu[language]}</li>
                        </ol>
                    </div>

                </div>}
            </div>
            {Util.Platform.isIOS() &&  <div >
                <img className={"mx-auto my-0 d-block"} src="/images/icons/icon_ios_download.png" height="52px" />
            </div>}
            </div>

    </GamePageLayout>


}

export default HelpPage
